import CheckIcon from "@mui/icons-material/Check";
import EditIcon from "@mui/icons-material/Edit";
import ErrorIcon from "@mui/icons-material/Error";
import InfoIcon from "@mui/icons-material/Info";
import {
  CircularProgress,
  ClickAwayListener,
  IconButton,
  styled,
  Tooltip,
} from "@mui/material";
import { FC } from "react";
import useFreightQuotePriceInput from "./useFreightQuotePriceInput";

const StyledIconButton = styled(IconButton)({
  width: 21,
  height: 21,
  padding: 0,
  "& .MuiSvgIcon-root": { fontSize: 21 },
});

const StyledErrIcon = styled(ErrorIcon)({
  color: "crimson",
  fontSize: 20,
  marginRight: 10,
});

const StyledInfoIcon = styled(InfoIcon)({
  color: "gray",
  fontSize: 20,
  marginRight: 10,
});

const Loader: FC = () => {
  return (
    <div style={{ width: 18, height: 18, marginLeft: 10 }}>
      <CircularProgress size={18} color="primary" />
    </div>
  );
};

interface FreightQuotePriceInputProps {
  quoteId: string;
  initialFreightQuotePrice: number | null | undefined;
  initialFreightQuotePriceUpdateRequired: boolean;
}

export const FreightQuotePriceInput: FC<FreightQuotePriceInputProps> = ({
  quoteId,
  initialFreightQuotePrice,
  initialFreightQuotePriceUpdateRequired,
}) => {
  const {
    freightQuotePrice,
    handleEditFreightQuotePriceClick,
    editFreightQuotePriceClicked,
    handleConfirmFreightQuotePriceClick,
    isUpdatingFreightQuotePrice,
    handleFreightQuotePriceChange,
    handleFreightQuotePriceBlur,
    handleFreightQuotePriceClickAway,
    freightQuotePriceUpdateRequired
  } = useFreightQuotePriceInput(quoteId, initialFreightQuotePrice, initialFreightQuotePriceUpdateRequired);

  return (
    <ClickAwayListener onClickAway={handleFreightQuotePriceClickAway}>
      <div
        style={{
          display: "flex",
          justifyContent: "end",
          alignItems: "center",
        }}
      >
        {freightQuotePriceUpdateRequired ? (
          <Tooltip
            title="Please update freight price due to Estes API issue!"
            placement="top"
            enterTouchDelay={0}
          >
            <StyledErrIcon />
          </Tooltip>
        ) : <Tooltip
            title="Freight price can be updated due to Estes API Issue."
            placement="top"
            enterTouchDelay={0}
          >
            <StyledInfoIcon />
          </Tooltip>}
        <input
          maxLength={20}
          style={{ width: 75 }}
          value={freightQuotePrice}
          onChange={(e) => handleFreightQuotePriceChange(e)}
          onBlur={handleFreightQuotePriceBlur}
          name="freightPrice"
          type="text"
          placeholder=""
          disabled={!editFreightQuotePriceClicked || isUpdatingFreightQuotePrice}
        />
        {!editFreightQuotePriceClicked ? (
          <StyledIconButton
            style={{ marginLeft: 10 }}
            onClick={handleEditFreightQuotePriceClick}
          >
            <EditIcon color={"cyan" as "primary"} />
          </StyledIconButton>
        ) : !isUpdatingFreightQuotePrice ? (
          <StyledIconButton
            style={{ marginLeft: 10 }}
            onClick={() => handleConfirmFreightQuotePriceClick()}
            disabled={freightQuotePrice === "2222.00"}
          >
            <CheckIcon color={"cyan" as "primary"} />
          </StyledIconButton>
        ) : (
          <Loader />
        )}
      </div>
    </ClickAwayListener>
  );
};
